export default __webpack_public_path__ + "static/media/metal.d1bf62ac.svg";